module.exports = __webpack_public_path__ + "img/818ccad.png";